import Vue from "vue";
import Vuex from "vuex";

import common from "./modules/common";
import compontents from "./modules/compontents";
import users from "./modules/users";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    common,
    compontents,
    users,
  },
});
